








































import { Component, Vue } from 'vue-property-decorator'
import BaseForm from '@/components/reusable-components/form/BaseForm.vue'
import FormField from '@/components/reusable-components/form/FormField.vue'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import { ButtonTheme, ButtonType } from '@/utils/ButtonAttr'
import API from '@/services/API'
import { Member } from '@/types/Member.type'
import { namespace } from 'vuex-class'
import AuthUpdateAvatar from '@/components/auth/AuthUpdateAvatar.vue'
import TranslationModule from '@/utils/TranslationModule'
import FormLabel from '@/components/reusable-components/form/FormLabel.vue'

const User = namespace('user')

@Component({
    components: { FormLabel, AuthUpdateAvatar, BaseButton, FormField, BaseForm },
})
export default class AuthUpdateProfile extends Vue {
    @User.State me!: Member
    pending = false
    ButtonTheme: typeof ButtonTheme = ButtonTheme
    ButtonType: typeof ButtonType = ButtonType
    TranslationModule: typeof TranslationModule = TranslationModule
    form: {
        firstname: string
        lastname: string
        email: string
    } | null = null

    $refs!: {
        form: BaseForm
    }

    async mounted() {
        await this.$store.dispatch('user/getMe', true)
        this.form = {
            firstname: this.me.first_name,
            lastname: this.me.last_name,
            email: this.me.email,
        }
    }

    handleUpdate() {
        if (!this.pending && this.form !== null) {
            this.pending = true
            const updateForm: any = {}
            Object.keys(this.form).forEach((key: string) => {
                // @ts-ignore
                if (this.form[key] !== '') {
                    // @ts-ignore
                    updateForm[key] = this.form[key]
                }
            })

            API.patchMe(updateForm)
                .then(async data => {
                    // Reset member token
                    if (data && data.jwt && data.jwt.token) {
                        await this.$store.dispatch('user/setToken', { token: data.jwt.token })
                    }
                    await this.$store.dispatch('user/setMe', null)
                    await this.$store.dispatch('user/getMe')
                    this.$notify({
                        type: 'success',
                        text: this.$trans('auth.update.success', TranslationModule.COMMON),
                    })
                })
                .catch(error => {
                    this.$refs.form.setErrors({
                        form: 'Une erreur est survenue, veuillez rééssayer',
                    })

                    const errors = error && error.response && error.response.data && error.response.data.errors
                    if (errors && Object.keys(errors).length) {
                        Object.keys(errors).forEach((field: string) => {
                            this.$refs.form.setErrors({
                                [`update_${field}`]: errors[field] as string | string[],
                            })
                        })
                    }
                })
                .finally(() => {
                    this.pending = false
                })
        }
    }
}
